// src/pages/CareerPage.jsx
import React, { useRef, useState, useEffect } from "react";
import { Container, Button } from "react-bootstrap";
// Import with NO trailing space, and make sure the file exists at this path:
import MultiStepApplication from "../components/MultiStepApplication";

export default function CareerPage() {
  const [showWizard, setShowWizard] = useState(false);
  const wizardRef = useRef(null);
  const NAV_HEIGHT = 96; // adjust if your fixed navbar is taller/shorter

  const handleApplyNow = () => {
    setShowWizard(true);
    // Scroll after it renders
    setTimeout(() => {
      const el = wizardRef.current;
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.pageYOffset - NAV_HEIGHT;
      window.scrollTo({ top: y, behavior: "smooth" });
    }, 0);
  };
  useEffect(() => {
    if (showWizard) {
      requestAnimationFrame(() => {
        wizardRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [showWizard]);

  return (
    <div className="bg-light">
      {/* HERO / CTA */}
      <section className="py-5 text-center">
        <Container>
          <h2 className="fw-bold text-primary">Benefits at AllWell Companion Home Care</h2>
          <p className="text-muted mb-4">
            We offer employees a full range of benefits, from competitive salaries and wages to health insurance.
          </p>

          <div className="d-flex gap-3 justify-content-center">
            <Button variant="primary" onClick={() => setShowWizard(true)}>
              APPLY NOW
            </Button>
            {/* <Button variant="dark">GET THE TRAINING</Button> */}
          </div>
        </Container>
      </section>

      {/* Multi-step application */}
      {showWizard && (
        <section id="application-form" ref={wizardRef} className="py-4 scroll-offset">
          <MultiStepApplication />
        </section>
      )}
    </div>
  );
}
